import { crmRequest } from './crmApi';
export async function companyOpportunities(companyId) {
    const items = [];
    for (let page = 1; ; page++) {
        const result = await crmRequest(`/opportunities?company=${companyId}&pageSize=100&page=${page}`);
        items.push(...result.items);
        if (!result.items.length || items.length >= result.total) return items;
    }
}
